import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Enregistre la vue de page chaque fois que l'objet 'location' change
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title // Utilise le titre actuel de la page
    });
    console.log("GA4 Page view sent:", location.pathname);

  }, [location]);
};

export default usePageTracking;